export default __webpack_public_path__ + "static/media/unitabriz.cedf5aa1.png";